import { Component } from '@angular/core';
import {SessionsQuickCardComponent} from "../sessions/sessions-quick-card/sessions-quick-card.component";
import {TemplatingQuickCardComponent} from "../templating/templating-quick-card/templating-quick-card.component";
import {ChatbotsQuickCardComponent} from "../chatbots/chatbots-quick-card/chatbots-quick-card.component";
import {TenantsQuickCardComponent} from "../tenants/tenants-quick-card/tenants-quick-card.component";
import {RequireRoleDirective} from "../../auth/components/require-role.directive";
import {RequireClaimsDirective} from "../../auth/components/require-claims.directive";
import {UsersQuickCardComponent} from "../users/users-quick-card/users-quick-card.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-rag-dashboard',
  standalone: true,
  imports: [
    SessionsQuickCardComponent,
    TemplatingQuickCardComponent,
    ChatbotsQuickCardComponent,
    TenantsQuickCardComponent,
    RequireRoleDirective,
    RequireClaimsDirective,
    UsersQuickCardComponent,
    NgIf
  ],
  templateUrl: './rag-dashboard.component.html',
})
export class RagDashboardComponent {
}
